import { render, staticRenderFns } from "./ProviderGasPrice.vue?vue&type=template&id=d06936d2&scoped=true&"
import script from "./ProviderGasPrice.vue?vue&type=script&lang=js&"
export * from "./ProviderGasPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06936d2",
  null
  
)

export default component.exports